export const LODS = ['100', '200', '300', '350', '400', '500']
export interface NameValuePair {
    name: string
    value: string
}

export interface NameValueBooleanPair {
    name: string
    value: boolean
}

export const STATUS: NameValuePair[] = [
    {
        name: 'New',
        value: 'NEW',
    },
    {
        name: 'Active',
        value: 'ACTIVE',
    },
    {
        name: 'Review Needed',
        value: 'REVIEWNEEDED',
    },
    {
        name: 'In Review',
        value: 'INREVIEW',
    },
    {
        name: 'Needs Coordination',
        value: 'NEEDSCOORDINATION',
    },
    {
        name: 'Complete',
        value: 'COMPLETE',
    },
]

export const TYPE: NameValuePair[] = [
    {
        name: 'Assembly',
        value: 'ProjectUniformatClassification',
    },
    {
        name: 'Family',
        value: 'ProjectProductFamily',
    },
    {
        name: 'Product Type',
        value: 'ProjectNugget',
    },
    {
        name: 'Sustainability Topic',
        value: 'SustainabilityTopic',
    },
]
export const TYPEAE: NameValuePair[] = [
    {
        name: 'Assembly',
        value: 'ProjectUniformatClassification',
    },
    {
        name: 'Family',
        value: 'ProjectProductFamily',
    },
    {
        name: 'Product Type',
        value: 'ProjectNugget',
    },
]
export const TYPEBP: NameValuePair[] = [
    {
        name: 'Family',
        value: 'ProjectProductFamily',
    },
]

export const SMMSTATUS: NameValueBooleanPair[] = [
    {
        name: 'Draft',
        value: true,
    },
    {
        name: 'Published',
        value: false,
    },
]
